/**
 * Created by yoavp on 10/11/2015.
 */
define(function (require) {
    "use strict";

    var LE = require("app");
    var ROLES = require("user-management-assets/data/roles.json");

    var UsersFilters = [];

    function moduleDefinition(LEUserManagement, LE, Backbone, Marionette, $, _) {
        UsersFilters = [{
            name: "groups",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function () {
                var dataManager = LEUserManagement.getDataManager();
                var agentGroupsCollection = dataManager.getData(dataManager.getEntities().AGENT_GROUP);
                var valuesArr = [];

                // if the user has specific privileges - build the groups options only according to the user he has privileges to view
                if (!LEUserManagement.hasAllUsersViewPrivilege()) {
                    var usersCollection = dataManager.getData(dataManager.getEntities().USER);
                    var privileges = {viewAll:LEUserManagement.hasAllUsersViewPrivilege(), editAgent: LEUserManagement.hasAgentUserEditPrivilege(), editAgentManager: LEUserManagement.hasAgentManagerUserEditPrivilege()};
                    var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                    var profilesCollection = dataManager.getData(dataManager.getEntities().PROFILES);
                    usersCollection.each(function(userModel) {
                        if (userModel.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser, profilesCollection)) {
                            var groups = userModel.getGroups(agentGroupsCollection);
                            _.each(groups, function(groupObj) {
                                valuesArr.push({id: groupObj.name, value: groupObj.name});
                            });
                        }
                    });
                }
                else {
                    agentGroupsCollection.each(function (agentGroupModel) {
                        valuesArr.push({id: agentGroupModel.getName(), value: agentGroupModel.getName()});
                    });
                }

                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.agentGroupList.column.name.filter.placeholder")
                };
            }
        }, {
            name: "roles",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function () {
                var dataManager = LEUserManagement.getDataManager();
                var valuesArr = [];

                // if the user has specific privileges - build the roles options only according to the user he has privileges to view
                if (!LEUserManagement.hasAllUsersViewPrivilege()) {
                    var usersCollection = dataManager.getData(dataManager.getEntities().USER);
                    var privileges = {viewAll:LEUserManagement.hasAllUsersViewPrivilege(), editAgent: LEUserManagement.hasAgentUserEditPrivilege(), editAgentManager: LEUserManagement.hasAgentManagerUserEditPrivilege()};
                    var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                    var profilesCollection = dataManager.getData(dataManager.getEntities().PROFILES);
                    usersCollection.each(function(userModel) {
                        if (userModel.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser, profilesCollection)) {
                            var userRoles = _.map(userModel.getProfiles(), _.bind(function(userProfileId) {
                                var profileModel = profilesCollection.get(userProfileId);
                                return profileModel.getRoleTypeId().toString();
                            }, this));

                            _.each(userRoles, function(userRoleId) {
                                valuesArr.push({id:  parseInt(userRoleId, 10), value: LE.translator.translate(ROLES[userRoleId])});
                            });
                        }
                    });
                }
                else {
                    _.each(ROLES, function(value, key) {
                        valuesArr.push({id: parseInt(key, 10), value: LE.translator.translate(value)});
                    });
                }

                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.roles.column.name.filter.placeholder")
                };
            }
        }, {
            name: "profiles",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function () {
                var dataManager = LEUserManagement.getDataManager();
                var valuesArr = [];
                var profilesCollection = dataManager.getData(dataManager.getEntities().PROFILES);

                // if the user has specific privileges - build the profiles options only according to the user he has privileges to view
                if (!LEUserManagement.hasAllUsersViewPrivilege()) {
                    var usersCollection = dataManager.getData(dataManager.getEntities().USER);
                    var privileges = {viewAll:LEUserManagement.hasAllUsersViewPrivilege(), editAgent: LEUserManagement.hasAgentUserEditPrivilege(), editAgentManager: LEUserManagement.hasAgentManagerUserEditPrivilege()};
                    var groupsUnderLoggedInUser = dataManager.getData(dataManager.getEntities().AGENT_MANAGER_MODEL).getGroups();
                    usersCollection.each(function(userModel) {
                        if (userModel.isViewableForLoggedInUser(privileges, groupsUnderLoggedInUser, profilesCollection)) {
                            _.each(userModel.getProfiles(), _.bind(function(userProfileId) {
                                var profileModel = profilesCollection.get(userProfileId);
                                valuesArr.push({id: profileModel.id, value: profileModel.getName()});
                            }, this));
                        }
                    });
                }
                else {
                    profilesCollection.each(function (profileModel) {
                        valuesArr.push({id: profileModel.id, value: profileModel.getName()});
                    });
                }

                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.profiles.column.name.filter.placeholder")
                };
            }
        },{
            name: "skills",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function (options) {
                var gridModel = options.gridModel;
                var dataManager = LEUserManagement.getDataManager();
                var valuesArr = [];
                var skillsCollection = dataManager.getSkillsCollection();

                skillsCollection.each(function (skillModel) {
                            valuesArr.push({id: skillModel.id, value: skillModel.getName()});
                }, this);

                valuesArr.push({id: gridModel.NO_SKILLS_VALUE, value:LE.translator.translate("LEUserManagement.userList.column.skills.filter.unassigned")});

                return {
                    valuesArr: valuesArr,
                    placeholderText: LE.translator.translate("LEUserManagement.skills.column.name.filter.placeholder")
                };
            }
        }, {
                name: "userType",
                type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

                getFilterData: function () {
                    var dataManager = LEUserManagement.getDataManager();
                    var usersCollection = dataManager.getData(dataManager.getEntities().USER);
                    var userTypes = usersCollection.model.USER_TYPES;
                    var userTypesKeys = usersCollection.model.USER_TYPES_KEYS;
                    var valuesArr = _.map(userTypes, function(val){
                        return {id: val, value: LE.translator.translate("LEUserManagement.userEdit.userType." +  userTypesKeys[val])};
                    });

                    return {
                        valuesArr: valuesArr,
                        placeholderText: LE.translator.translate("LEUserManagement.types.column.name.filter.placeholder")
                    };
                }
        }, {
            name: "lobs",
            type: Marionette.GridView.FILTERS.TYPES.MULTISELECT,

            getFilterData: function (options) {
                var gridModel = options.gridModel;
                var allowedLobs = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.getAllowedLobs);
                var isAllLobsAllowedForUser = LE.crossModule("dataModule", LE.media.actions.request, LE.mediaCodes.dataModule.reqres.isAllLobsAllowedForUser);

                var valuesArr = [];

                _.each(allowedLobs, function (lobModel) {
                    valuesArr.push({id: lobModel.id, value: lobModel.getName()});
                });

                if (isAllLobsAllowedForUser) {
                    valuesArr.push({id: gridModel.NO_LOBS_VALUE, value:LE.translator.translate("LEUserManagement.lobs.column.name.filter.noLobs")});
                }


                return {valuesArr: valuesArr, placeholderText: LE.translator.translate("LEUserManagement.lobs.column.name.filter.placeholder")};
            }
        }
        ];
    }

    LE.module("LEUserManagement", moduleDefinition);

    return UsersFilters;
});

//


